import styled from "styled-components";

/** A white panel (soft shadow in light, hairline in dark): the new look's basic card. */
const Surface = styled.div<{ $padding?: number | string }>`
  background: ${(p) => p.theme.colors.cardBgColor};
  border: ${(p) => p.theme.borders.panel};
  border-radius: ${(p) => p.theme.radii.card}px;
  box-shadow: ${(p) => p.theme.shadows.panel};
  padding: ${(p) =>
    typeof p.$padding === "number" ? `${p.$padding}px` : p.$padding ?? "20px"};
  min-width: 0;
  @media (max-width: 600px) {
    border-radius: 12px;
    padding: ${(p) =>
      p.$padding === undefined
        ? "14px"
        : typeof p.$padding === "number"
        ? `${p.$padding}px`
        : p.$padding};
  }
`;

export default Surface;
